import { Capacitor } from '@capacitor/core'

export type NativePlatform = 'ios' | 'android' | 'web'

type CapacitorWindow = Window & {
  androidBridge?: unknown
  webkit?: {
    messageHandlers?: {
      bridge?: unknown
    }
  }
}

const getBridgePlatform = (): NativePlatform => {
  if (typeof window === 'undefined') {
    return 'web'
  }

  const capacitorWindow = window as CapacitorWindow

  if (capacitorWindow.androidBridge) {
    return 'android'
  }

  if (capacitorWindow.webkit?.messageHandlers?.bridge) {
    return 'ios'
  }

  return 'web'
}

const getUserAgentPlatform = (): NativePlatform => {
  if (typeof navigator === 'undefined') {
    return 'web'
  }

  const userAgent = navigator.userAgent || ''

  if (!/Capacitor/i.test(userAgent)) {
    return 'web'
  }

  if (/Android/i.test(userAgent)) {
    return 'android'
  }

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'ios'
  }

  return 'web'
}

export const getNativePlatform = (): NativePlatform => {
  const bridgePlatform = getBridgePlatform()
  if (bridgePlatform !== 'web') {
    return bridgePlatform
  }

  if (Capacitor.isNativePlatform()) {
    const platform = Capacitor.getPlatform()
    return platform === 'ios' || platform === 'android' ? platform : 'web'
  }

  return getUserAgentPlatform()
}

export const isNativeShell = (): boolean => getNativePlatform() !== 'web'

export const prepareRecaptchaContainer = (
  containerId: string,
  useVisibleRecaptcha: boolean
): HTMLElement => {
  const container = document.getElementById(containerId)

  if (!container) {
    throw new Error(`Missing reCAPTCHA container #${containerId}`)
  }

  container.replaceChildren()
  container.classList.toggle('recaptcha-container--visible', useVisibleRecaptcha)
  container.classList.toggle('recaptcha-container--hidden', !useVisibleRecaptcha)

  return container
}
